import React, { useState, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import LabelMessage from './LabelMessage';
import './CustomCaptcha.scss';
import {Capacitor} from "@capacitor/core";

interface ReCAPTCHAProps {
    onVerify: (verified: boolean, token: string) => void;
    useCache:boolean
}

// Site key pública de reCAPTCHA; configurable por entorno para evitar el hallazgo de "hardcoded credential" del scanner
const sitekey = process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? "";
const hl = 'es';

const CustomReCAPTCHA: React.FC<ReCAPTCHAProps> = ({ onVerify,useCache }) => {
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
    const [showCaptcha, setShowCaptcha] = useState(true);

    useEffect(() => {

        if(Capacitor.isNativePlatform()){
            setIsCaptchaVerified(true);
            setShowCaptcha(false);
            onVerify(true, 'NativePlatform');
            return;
        }
        // Check if captcha was already verified in this session
        const captchaVerified = useCache?sessionStorage.getItem('captchaVerified'):null;
        var expirationTime=useCache?sessionStorage.getItem('captchaExpiration'):null;

        if (captchaVerified === 'true'&&expirationTime!=null) {
            if (Date.now() < Number(expirationTime)) {
                setIsCaptchaVerified(true);
                setShowCaptcha(false);
                onVerify(true, ''); // Notify parent that captcha is already verified
            }else{
                setShowCaptcha(true);
                sessionStorage.removeItem('captchaVerified');
                sessionStorage.removeItem('captchaExpiration');// Save verification in session
            }
        }else
            setShowCaptcha(true);
    }, [onVerify]);

    const handleCaptchaChange = (value: string | null) => {
        if (value) {
            setIsCaptchaVerified(true);
            if(useCache){
                const expirationTime = Date.now() + 90 * 60 * 1000; // 90 minutes in milliseconds
                sessionStorage.setItem('captchaVerified', 'true');
                sessionStorage.setItem('captchaExpiration', expirationTime+"");// Save verification in session
            }
            onVerify(true, value);
        }

    };
    const onExpired = () => {
        if(!useCache){
            onVerify(false, "");
        }
    };

    return (
        <div className='recatpcha'>
            {showCaptcha && (
                <ReCAPTCHA sitekey={sitekey} hl={hl} onChange={handleCaptchaChange} onExpired={onExpired} />
            )}
            {!isCaptchaVerified && (
                <LabelMessage valid={isCaptchaVerified} isLabelError={true} message={`Por favor, verifica el captcha antes de continuar`} />
            )}
        </div>
    );
};

export default CustomReCAPTCHA;